module.exports = __webpack_public_path__ + "img/flag-ES.090d1261.png";